import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

//import components
import PrimaryStepper from "../../../components/_utils/CommonSteppers/PrimaryStepper";
import SmallPopup from "../../../components/_utils/CommonSmallPopup";
import SmallPopupWithInput from "../../../components/_utils/CommonSmallPopupWithInput";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton";
import PaginationComponent from "../../../components/_utils/PaginationComponent";
import SVGComponent from "../../../components/_utils/SVGComponent";
import LargePopupRedirect from "../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import PrivateTxnEntry from "../../../components/_utils/PrivateTxnEntry";
import CommonToast from "../../../components/_utils/CommonToast";

//import redux
import {
  getSpecificPrivateTransactions,
  invalidPrivateTxnEntry,
  ValidateEntries,
  getSpecificTransactionItems,
} from "../../../redux/features/privatetransactions/privatetransactions";

import { getRefreshTokenNew } from "../../../redux/features/refreshToken/refreshToken";

//import utils
import {
  errorcode,
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../utils/configurationProvider";
import { formatAccountNumber } from "../../../components/_utils/FormatAccountNumber";
import ICONS from "../../../assets/Icons";
import BeneficiaryAccountDetails from "../../Accounts/BeneficiaryAccount/BeneficiaryAccountDetails";

const PrivateTxnValidate = () => {
  const dispatch = useDispatch();

  const prevScrollTopRef = useRef(GlobalConfiguration.lengthCheckZero);
  const scrollableRef = useRef(null);
  const lastScrollTopRef = useRef(GlobalConfiguration.lengthCheckZero);

  const navigate = useNavigate();

  const { request_reference_id } = useParams();

  const [statuses, setStatuses] = useState({});
  const [visualStatuses, setVisualStatuses] = useState({});
  const [animating, setAnimating] = useState({});
  const [transitioning, setTransitioning] = useState({});
  const [slidingIn, setSlidingIn] = useState({});
  const [approveCount, setApproveCount] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const [rejectCount, setRejectCount] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const [beneAccDetailPopUp, setBeneAccDetailPopUp] = useState(false);
  const [currentPage, setCurrentPage] = useState(
    GlobalConfiguration.lengthCheckOne,
  );
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const [pageSize, setPageSize] = useState(
    dropdownOptions[GlobalConfiguration.lengthCheckZero],
  );
  const [selectedValue, setSelectedValue] = useState(
    dropdownOptions[GlobalConfiguration.lengthCheckZero],
  );

  const [cancelModal, setCancelModal] = useState(false);
  const [confirmValidationModal, setConfirmValidationModal] = useState(false);
  const [rejectValidationModal, setRejectValidationModal] = useState(false);
  const [narration, setNarration] = useState("");
  const [rejectionReason, setRejectionReason] = useState("");
  const [isReject, setIsReject] = useState(false);
  const [BeneAccID, setBeneAccID] = useState();
  const [bulkAction, setBulkAction] = useState(null);
  const [isOpen, setIsopen] = useState(false);
  const [showExtraInfo, setShowExtraInfo] = useState(true);
  const [activeStep] = useState(GlobalConfiguration.lengthCheckZero);

  const {
    specificPrivateTransactionsData,
    specificPrivateTransactionsLoading,
    getSpecificTransactionItemsData,
    getSpecificTransactionItemsLoading,
    getSpecificTransactionItemsError,
  } = useSelector((state) => state.privatetransactions);

  const updateCounts = (newStatuses) => {
    let a = GlobalConfiguration.lengthCheckZero;
    let r = GlobalConfiguration.lengthCheckZero;
    Object.values(newStatuses).forEach((s) => {
      if (s === "approve") a++;
      if (s === "reject") r++;
    });
    setApproveCount(a);
    setRejectCount(r);
  };
  const data = specificPrivateTransactionsData;
  const transactionItems =
    specificPrivateTransactionsData?.private_transaction?.transaction_items ||
    [];
  const getStatus = (id) => statuses[id] || "neutral";
  const getVisualStatus = (id) => visualStatuses[id] || "neutral";
  const privateTransactionId =
    data?.transaction_request?.private_transaction_id;

  const useClientSidePagination =
    !getSpecificTransactionItemsData || getSpecificTransactionItemsError;
  const totalCount = useClientSidePagination
    ? transactionItems.length
    : getSpecificTransactionItemsData?.total_count ||
      GlobalConfiguration.lengthCheckZero;
  const paginatedItems = useClientSidePagination
    ? transactionItems.slice(
        (currentPage - GlobalConfiguration.lengthCheckOne) * pageSize,
        currentPage * pageSize,
      )
    : getSpecificTransactionItemsData?.transaction_items || [];

  const paginationApiData = useClientSidePagination
    ? {
        total_count: totalCount,
        title: {
          current_page: currentPage,
          total_pages: Math.ceil(totalCount / pageSize),
          page_item_count: Math.min(pageSize, paginatedItems.length),
        },
      }
    : {
        total_count: totalCount,
        title: {
          current_page:
            getSpecificTransactionItemsData?.title?.current_page ||
            GlobalConfiguration.lengthCheckOne,
          total_pages:
            getSpecificTransactionItemsData?.title?.total_pages ||
            GlobalConfiguration.lengthCheckOne,
          page_item_count:
            getSpecificTransactionItemsData?.title?.page_item_count ||
            selectedValue,
        },
      };

  const isLoading =
    specificPrivateTransactionsLoading || getSpecificTransactionItemsLoading;
  const dataArray = [
    {
      stepperText: "Validate file",
      previousText: "Cancel",
      nextText: "Confirm",
      nextHoverOption: "black",
      nextIsEnabled:
        !isLoading &&
        paginatedItems.length > GlobalConfiguration.lengthCheckZero &&
        (approveCount === totalCount ||
          rejectCount > GlobalConfiguration.lengthCheckZero),
      nextEnableBgColor: "var(--positive-act)",
      nextDisableBgColor: "var(--text-disabled)",
      previousEnableBgColor: "var(--primary-nav-act)",
      previousDisableBgColor: "var(--bg_secondary)",

      extraInfoShow: true,
      extraInfoHeaderText:
        "The file can only be validated if all entries are valid. A single invalid entry will cause the entire transaction file to be rejected.",
      extraInfoIconUrl:
        "https://q2pay.in/new_assets/common/dashboard/alert.svg",
    },
  ];

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setSelectedValue(size);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
  };

  const triggerAnimation = (transactionId, newStatus) => {
    const currentVisual = getVisualStatus(transactionId);

    if (newStatus !== "neutral" && currentVisual === newStatus) return;

    if (newStatus === "neutral") {
      if (currentVisual === "neutral") return;

      setAnimating((prev) => ({ ...prev, [transactionId]: true }));
      setTimeout(() => {
        setVisualStatuses((prev) => ({ ...prev, [transactionId]: "neutral" }));
        setAnimating((prev) => ({ ...prev, [transactionId]: false }));
      }, errorcode.errorFailed);
    } else {
      setTransitioning((prev) => ({ ...prev, [transactionId]: newStatus }));
      setSlidingIn((prev) => ({ ...prev, [transactionId]: false }));

      requestAnimationFrame(() => {
        setSlidingIn((prev) => ({ ...prev, [transactionId]: true }));
      });

      setTimeout(() => {
        setVisualStatuses((prev) => ({ ...prev, [transactionId]: newStatus }));
        setTransitioning((prev) => ({ ...prev, [transactionId]: undefined }));
        setSlidingIn((prev) => ({ ...prev, [transactionId]: undefined }));
      }, errorcode.errorFailed);
    }
  };

  const handleApprove = (transactionId) => {
    const current = getStatus(transactionId);
    const newStatus = current === "approve" ? "neutral" : "approve";
    if (current === newStatus) return;

    setStatuses((prev) => {
      const updated = { ...prev, [transactionId]: newStatus };
      updateCounts(updated);
      return updated;
    });

    triggerAnimation(transactionId, newStatus);
  };

  const handleReject = (transactionId) => {
    forceShowExtraInfo();

    const current = getStatus(transactionId);
    const newStatus = current === "reject" ? "neutral" : "reject";
    if (current === newStatus) return;

    setStatuses((prev) => {
      const updated = { ...prev, [transactionId]: newStatus };
      updateCounts(updated);

      if (Object.values(updated).includes("reject")) {
        setTimeout(() => {
          setIsReject(true);
          setRejectValidationModal(true);
        }, errorcode.errorFailed);
      }
      return updated;
    });

    triggerAnimation(transactionId, newStatus);
  };

  const onMount = () => {};

  const handleBackwardAction = () => setCancelModal(true);

  const handleForwardAction = () => {
    if (
      approveCount === GlobalConfiguration.lengthCheckZero &&
      rejectCount === GlobalConfiguration.lengthCheckZero
    )
      return;

    if (rejectCount > GlobalConfiguration.lengthCheckZero) {
      setIsReject(true);
      setRejectValidationModal(true);
    } else {
      setConfirmValidationModal(true);
    }
  };

  const handleCancelFunction = () => {
    setCancelModal(false);
  };

  const handleProceedToReject = () => {
    setCancelModal(false);
    navigate(GlobalConfiguration.navigate_back);
  };

  const handleConfirmBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      setConfirmValidationModal(false);
    }
  };

  const showActionErrorToast = () => {
    CommonToast({
      text: "An error occurred while taking action on this file.",
      icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
      variant: "var(--error)",
      buttonNeeded: false,
    });
  };
  const handleConfirmFile = () => {
    CommonToast({
      text: "Validating file",
      icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
      variant: "var(--processing)",
      buttonNeeded: false,
    });

    dispatch(
      ValidateEntries({
        private_transaction_id: privateTransactionId,
        narration,
      }),
    )
      .unwrap()
      .then(() => {
        CommonToast({
          text: "File validated successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          buttonNeeded: false,
        });
        navigate(GlobalConfiguration.navigate_back);
      })
      .catch(() => {
        showActionErrorToast();
        setBulkAction(false);
      });
  };

  const handleRejectFileFinal = () => {
    CommonToast({
      text: "Invalidating file",
      icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
      variant: "var(--processing)",
      buttonNeeded: false,
    });

    dispatch(
      invalidPrivateTxnEntry({
        private_transaction_id: privateTransactionId,
        rejection_reason: rejectionReason,
      }),
    )
      .unwrap()
      .then(() => {
        CommonToast({
          text: "File invalidated successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          buttonNeeded: false,
        });
        navigate(GlobalConfiguration.navigate_back);
      })
      .catch(() => {
        showActionErrorToast();
        setBulkAction(false);
      });
  };

  const handleRejectBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      setRejectValidationModal(false);
      setRejectionReason("");
    }
  };

  const handleBeneDetailPopUp = (ID) => {
    setBeneAccID(ID);
    setBeneAccDetailPopUp(!beneAccDetailPopUp);
  };

  const handleRejectCancel = () => {
    setBulkAction(false);
    setRejectValidationModal(false);
    setRejectionReason("");
    setIsReject(false);

    setStatuses((prev) => {
      const updated = { ...prev };
      Object.keys(updated).forEach((id) => {
        if (updated[id] === "reject") {
          delete updated[id];
        }
      });
      updateCounts(updated);
      return updated;
    });

    setVisualStatuses((prev) => {
      const updated = { ...prev };
      Object.keys(updated).forEach((id) => {
        if (updated[id] === "reject") {
          delete updated[id];
        }
      });
      return updated;
    });
  };

  const forceShowExtraInfo = () => {
    setShowExtraInfo(true);
    prevScrollTopRef.current = GlobalConfiguration.lengthCheckZero;
  };
  useEffect(() => {
    onMount();
  }, [dispatch]);

  useEffect(() => {
    const el = scrollableRef.current;
    if (!el) return;

    const onScroll = () => {
      const currentScrollTop = el.scrollTop;
      const lastScrollTop = lastScrollTopRef.current;

      const scrollHeight = el.scrollHeight;
      const clientHeight = el.clientHeight;

      const isAtBottom =
        scrollHeight - currentScrollTop - clientHeight <
        GlobalConfiguration.categorymaxLength;

      if (currentScrollTop < GlobalConfiguration.lengthCheckZero) {
        lastScrollTopRef.current = currentScrollTop;
        return;
      }

      if (isAtBottom) {
        setShowExtraInfo(false);
        lastScrollTopRef.current = currentScrollTop;
        return;
      }

      if (currentScrollTop > lastScrollTop) {
        setShowExtraInfo(false);
      } else if (currentScrollTop < lastScrollTop) {
        setShowExtraInfo(true);
      }

      lastScrollTopRef.current = currentScrollTop;
    };

    el.addEventListener("scroll", onScroll);
    return () => el.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (!request_reference_id) return;
    dispatch(getSpecificPrivateTransactions({ id: request_reference_id }));
  }, [request_reference_id]);

  useEffect(() => {
    if (!privateTransactionId) return;
    dispatch(
      getSpecificTransactionItems({
        private_transaction_id: privateTransactionId,
        page: currentPage,
        page_size: pageSize,
      }),
    );
  }, [privateTransactionId, currentPage, pageSize]);

  return (
    <div className="benetxnvalidate h-screen flex flex-col w-width-full">
      {cancelModal && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-max-zindex bg-opacity-dark-opacity">
          <SmallPopup
            headerTitle="Cancel file validation"
            subtext="Are you sure you want to cancel the validation process?"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderFontWeight="semibold"
            secondHeaderFontColor="text-primary"
            secondHeaderTextSize="font-sm"
            btnOneText="No"
            btnOneHandleFunction={handleCancelFunction}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Yes"
            btnTwoHandleFunction={handleProceedToReject}
            btnTwoEnabledBgColor="var(--failed)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsLoaderNeeded={true}
          />
        </div>
      )}
      {confirmValidationModal && (
        <div
          className="fixed top-top-base left-left-base w-full h-full flex items-center justify-center bg-PopUp-BackDrop z-max-zindex bg-opacity-dark-opacity"
          onClick={handleConfirmBackdropClick}
        >
          <SmallPopupWithInput
            headerTitle="Transaction Narration"
            subtext="Please provide a narration for this transaction."
            noteText="This narration will appear on the bank statement."
            inputPlaceholder="Narration"
            inputValue={narration}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-primary)"
            inputOnInput={(e) => setNarration(e.target.value)}
            inputIsFullWidth={true}
            inputFontKind="medium"
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              setConfirmValidationModal(false);
              setNarration("");
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnOneFullWidthRequired={false}
            btnOneDisabledBgColor="var(--bg_secondary)"
            btnOneDisabledTextColor="var(--text-secondary)"
            btnTwoText="Add"
            btnTwoHandleFunction={handleConfirmFile}
            btnTwoEnabledBgColor="var(--positive-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              narration.trim().length < GlobalConfiguration.searchMinLength
            }
            btnTwoHoverOption="black"
            btnTwoFullWidthRequired={false}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoDisabledTextColor="var(--text-primary)"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-sm"
            noteColor="text-secondary"
            btnTwoInActiveVariantNeeded
          />
        </div>
      )}
      {rejectValidationModal && (
        <div
          className="fixed top-top-base left-left-base w-full h-full flex items-center justify-center bg-PopUp-BackDrop z-max-zindex bg-opacity-dark-opacity"
          onClick={handleRejectBackdropClick}
        >
          <SmallPopupWithInput
            headerTitle="Reject file"
            subtext="Invalidating this file or an individual entry will result in rejection of the entire file. Please state the reason for rejecting this file."
            inputPlaceholder="Reason (at least 10 char)"
            inputValue={rejectionReason}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-primary)"
            inputOnInput={(e) => setRejectionReason(e.target.value)}
            inputIsFullWidth={true}
            inputFontKind="medium"
            btnOneText="Cancel"
            btnOneHandleFunction={handleRejectCancel}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnOneFullWidthRequired={false}
            btnOneDisabledBgColor="var(--bg_secondary)"
            btnOneDisabledTextColor="var(--text-secondary)"
            btnTwoText="Reject"
            btnTwoHandleFunction={handleRejectFileFinal}
            btnTwoEnabledBgColor="var(--failed)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              rejectionReason.trim().length < GlobalConfiguration.panLength
            }
            btnTwoHoverOption="black"
            btnTwoFullWidthRequired={false}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoDisabledTextColor="var(--text-primary)"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-sm"
            btnTwoInActiveVariantNeeded
          />
        </div>
      )}

      {beneAccDetailPopUp && (
        <div className="fixed top-top-base left-left-base w-full h-full flex items-center justify-center bg-PopUp-BackDrop z-max-zindex bg-opacity-dark-opacity">
          <LargePopupRedirect
            isscrollRequired={true}
            headerTitle="Beneficiary account details"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            headertextSize="font-md"
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={handleBeneDetailPopUp}
            closeicon={
              "https://q2pay.in/new_assets/common/create_flow/close.svg"
            }
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            handleFunction={() => {}}
            enabledBgColor={"var(--positive-act)"}
            hoverOption={"dark"}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            isDisabled={false}
            disabledTextColor={""}
            disabledBgColor={""}
            isLoading={false}
            buttonRef={null}
            inActiveVariantNeeded={false}
            isLoaderNeeded={false}
          >
            <BeneficiaryAccountDetails
              closeBeneAccountDetailModal={handleBeneDetailPopUp}
              bene_account_id={BeneAccID}
              type="bene_account_detail_modal"
            />
          </LargePopupRedirect>
        </div>
      )}
      <div
        className={`ptc-navbar-padding-div Qmd:h-[calc(var(--navbar-breadcrumb-height)-var(--dashed-line))] h-auto block Qlg:bg-primary-bg Qmd:bg-primary-nav ${showExtraInfo ? "bg-primary-card" : "bg-primary-bg"} relative z-z-index-header`}
      >
        <div className="Qmd:hidden flex bg-primary-nav gap-gap-md h-full items-center p-padding-md rounded-b-border-radius-md shadow-box-shadow-bottom">
          <div
            onClick={() => {
              navigate(
                "/private_transaction_dashboard/private_transaction_view_all",
              );
            }}
            className="cursor-pointer"
          >
            <SVGComponent
              url="https://q2pay.in/new_assets/common/arrows/arrow_left_white.svg"
              width="var(--font-md)"
              height="var(--font-md)"
              color="var(--text-primary)"
            />
          </div>
          <div>
            <div className="text-text-primary text-font-md">
              Private transaction
            </div>
            <p className="text-text-secondary text-font-xs">Validate file</p>
          </div>
        </div>
      </div>
      <div
        className={`Qsmd:hidden bg-primary-card w-full overflow-hidden transition-all duration-animation-fast-s ease-in-out
    ${showExtraInfo ? "max-h-[var(--stepper-header)] opacity-base-opacity py-padding-button-l" : "max-h-right-base opacity-opacity-none py-padding-base"}
  `}
      >
        <div className="flex gap-gap-sm pl-padding-button-l items-center">
          <img
            src="https://q2pay.in/new_assets/common/dashboard/alert.svg"
            alt=""
            className="w-icon-md h-icon-md"
          />

          <span className="text-text-primary text-font-xs pr-padding-button-l">
            The file can only be validated if all entries are valid. A single
            invalid entry will cause the entire transaction file to be rejected.
          </span>
        </div>
      </div>

      <div
        className={`flex flex-col bg-primary-bg overflow-y-hidden relative ${showExtraInfo ? "Qsmd:min-h-detail-page-status gap-gap-md" : "gap-gap-lg"}`}
      >
        <div className="right-right-base left-left-base z-z-index-header flex flex-col">
          <div className="w-width-full justify-center z-z-index-content flex">
            <div
              className={`w-full Qsmd:w-std-width fixed bottom-bottom-base Qsmd:relative ${showExtraInfo ? "Qsmd:min-h-detail-page-status min-h-stepper-height" : "min-h-stepper-height"}`}
            >
              <PrimaryStepper
                activeStep={activeStep}
                handleForwardAction={handleForwardAction}
                handleBackwardAction={handleBackwardAction}
                dataArray={dataArray}
                showExtraInfo={showExtraInfo}
              />
            </div>
          </div>
        </div>
        {!isLoading && (
          <div className="w-width-full flex flex-col items-center px-padding-md">
            <div className=" max-w-tab-width-normal w-width-full bg-primary-nav rounded-border-radius-md hidden Qsmd:flex justify-between">
              <div className="validations_left flex pl-padding-md py-padding-md w-width-md">
                <div className="valid_txn w-width-full max-w-width-section flex-col flex items-start justify-center">
                  <span
                    className={`${approveCount > GlobalConfiguration.lengthCheckZero ? "text-positive-act" : "text-text-primary"} text-font-sm font-semibold`}
                  >
                    {approveCount}
                  </span>
                  <p className="text-text-primary text-font-xs font-normal">
                    Valid transactions
                  </p>
                </div>

                <div className="invalid_txn w-width-sm-1-3 flex-col flex items-start justify-center border-l-border border-primary-bg pl-padding-md ml-margin-sm ">
                  <span
                    className={`${rejectCount > GlobalConfiguration.lengthCheckZero ? "text-negative-act" : "text-text-primary"} text-font-sm font-semibold`}
                  >
                    {rejectCount}
                  </span>
                  <p className="text-text-primary text-font-xs font-normal">
                    Invalid transactions
                  </p>
                </div>
              </div>

              <div className="validations_right w-width-sm-1-3 py-padding-md flex gap-gap-md justify-end items-center pr-padding-md">
                <PrimaryButton
                  btnText="Invalidate file"
                  handleFunction={() => {
                    if (bulkAction === "invalidate") return;

                    setBulkAction("invalidate");

                    const newStatuses = {};
                    const txnIds = [];

                    transactionItems.forEach((txn) => {
                      const id = txn.transaction_item_id;
                      txnIds.push(id);
                      newStatuses[id] = "reject";
                    });

                    const updated = { ...statuses, ...newStatuses };
                    setStatuses(updated);
                    updateCounts(updated);
                    txnIds.forEach((id) => triggerAnimation(id, "reject"));

                    setTimeout(() => {
                      setIsReject(true);
                      setRejectValidationModal(true);
                    }, errorcode.errorFailed);
                  }}
                  enabledBgColor="var(--negative-act)"
                  enabledTextColor="var(--text-primary)"
                  isDisabled={bulkAction === "invalidate"}
                />

                <PrimaryButton
                  btnText="Validate file"
                  handleFunction={() => {
                    if (bulkAction === "validate") return;

                    setBulkAction("validate");

                    const newStatuses = {};
                    const txnIds = [];

                    transactionItems.forEach((txn) => {
                      const id = txn.transaction_item_id;
                      txnIds.push(id);
                      newStatuses[id] = "approve";
                    });

                    const updated = { ...statuses, ...newStatuses };
                    setStatuses(updated);
                    updateCounts(updated);
                    txnIds.forEach((id) => triggerAnimation(id, "approve"));
                  }}
                  enabledBgColor="var(--positive-act)"
                  enabledTextColor="var(--text-primary)"
                  isDisabled={bulkAction === "validate"}
                />
              </div>
            </div>

            <div className=" max-w-tab-width-normal w-width-full bg-primary-nav rounded-border-radius-md Qsmd:hidden flex flex-col justify-between">
              <div className="validations_left flex justify-between w-full pt-padding-md flex-row-reverse">
                <div className="valid_txn gap-gap-xs flex-row-reverse flex items-start justify-end w-width-md">
                  <span
                    className={`${approveCount > GlobalConfiguration.lengthCheckZero ? "text-positive-act" : "text-text-primary"} text-font-sm font-semibold`}
                  >
                    {approveCount}
                  </span>
                  <p className="text-text-primary text-font-xs font-normal">
                    Valid transactions:
                  </p>
                </div>

                <div className="h-[var(--icon-md)] w-[var(--border)] bg-primary-bg mx-margin-md"></div>

                <div className="invalid_txn gap-gap-xs flex-row-reverse flex items-start w-width-md justify-end pl-padding-lg">
                  <span
                    className={`${rejectCount > GlobalConfiguration.lengthCheckZero ? "text-negative-act" : "text-text-primary"} text-font-sm font-semibold`}
                  >
                    {rejectCount}
                  </span>
                  <p className="text-text-primary text-font-xs font-normal">
                    Invalid transactions:
                  </p>
                </div>
              </div>

              <div className="validations_right pb-padding-md pt-padding-sm flex gap-gap-md justify-end items-center px-padding-md">
                <PrimaryButton
                  btnText="Invalidate file"
                  handleFunction={() => {
                    if (bulkAction === "invalidate") return;

                    setBulkAction("invalidate");

                    const newStatuses = {};
                    const txnIds = [];

                    transactionItems.forEach((txn) => {
                      const id = txn.transaction_item_id;
                      txnIds.push(id);
                      newStatuses[id] = "reject";
                    });

                    const updated = { ...statuses, ...newStatuses };
                    setStatuses(updated);
                    updateCounts(updated);
                    txnIds.forEach((id) => triggerAnimation(id, "reject"));

                    setTimeout(() => {
                      setIsReject(true);
                      setRejectValidationModal(true);
                    }, errorcode.errorFailed);
                  }}
                  enabledBgColor="var(--negative-act)"
                  fullWidthRequired
                  enabledTextColor="var(--text-primary)"
                  isDisabled={bulkAction === "invalidate"}
                />

                <PrimaryButton
                  fullWidthRequired
                  btnText="Validate file"
                  handleFunction={() => {
                    if (bulkAction === "validate") return;

                    setBulkAction("validate");

                    const newStatuses = {};
                    const txnIds = [];

                    transactionItems.forEach((txn) => {
                      const id = txn.transaction_item_id;
                      txnIds.push(id);
                      newStatuses[id] = "approve";
                    });

                    const updated = { ...statuses, ...newStatuses };
                    setStatuses(updated);
                    updateCounts(updated);
                    txnIds.forEach((id) => triggerAnimation(id, "approve"));
                  }}
                  enabledBgColor="var(--positive-act)"
                  enabledTextColor="var(--text-primary)"
                  isDisabled={bulkAction === "validate"}
                />
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="validation_transactions_container flex-1 overflow-hidden bg-primary-bg flex justify-center z-z-index-base">
        <div
          ref={scrollableRef}
          className="validation_transactions_cards flex-1 overflow-y-scroll w-width-full pb-padding-xl gap-gap-md flex flex-col"
        >
          <div className="w-full" />
          {isLoading ? (
            <div className="w-full h-full flex items-center justify-center py-padding-xl">
              <img
                className="w-loader-lg h-loader-lg"
                src="https://q2pay.in/new_assets/gifs/inputloader_white.gif"
                alt=""
              />
            </div>
          ) : paginatedItems.length > GlobalConfiguration.lengthCheckZero ? (
            <div className="entries-wrapper w-full flex flex-col gap-gap-md Qlg:gap-gap-sm items-center px-padding-md Qlg:pb-padding-base pb-padding-lg">
              {paginatedItems.map((txn) => {
                const txnId = txn.transaction_item_id;

                return (
                  <>
                    <PrivateTxnEntry
                      key={txnId}
                      column1Title={txn.name || "Unknown User"}
                      column1Subtitle="Beneficiary name"
                      onColumn1Click={() =>
                        handleBeneDetailPopUp(txn.beneficiary_account_id)
                      }
                      column2Title={formatAccountNumber(
                        txn.beneficiary_account,
                      )}
                      column2Subtitle="Beneficiary account"
                      ifsc={txn.beneficiary_account_ifsc}
                      column3Title={txn.amount}
                      column3Subtitle="Transaction amount"
                      showCurrencySymbol={true}
                      showActions={true}
                      visualStatus={getVisualStatus(txnId)}
                      transitionStatus={transitioning[txnId]}
                      isSlidingIn={slidingIn[txnId]}
                      isAnimating={animating[txnId]}
                      button1={{
                        icon: ICONS.CLOSE,
                        tooltip: "Invalidate",
                        enabledBgColor: "var(--negative-act)",
                        bgClass: "bg-negative-bg",
                        onClick: () => handleReject(txnId),
                        isDisabled: getStatus(txnId) === "reject",
                      }}
                      button2={{
                        icon: ICONS.CHECKMARK_WHITE,
                        tooltip: "Validate",
                        enabledBgColor: "var(--positive-act)",
                        bgClass: "bg-positive-bg",
                        onClick: () => handleApprove(txnId),
                        isDisabled: getStatus(txnId) === "approve",
                      }}
                    />
                  </>
                );
              })}
            </div>
          ) : (
            <div className="w-full flex items-center justify-center py-padding-xl">
              <p className="text-text-secondary text-font-md">
                No transaction items to validate.
              </p>
            </div>
          )}
        </div>
      </div>
      <div
        style={{
          width: "var(--width-full)",
          backgroundColor: "var(--primary-nav)",
        }}
        className="Qsmd:bottom-bottom-base z-z-index-content Qsmd:pb-padding-base pb-padding-md mb-margin-sm Qsmd:mb-margin-base bottom-[var(--pagination-height)] Qlg:z-z-index-dropdown relative"
      >
        <PaginationComponent
          data={paginationApiData}
          handlePagination={handlePageChange}
          handleSelect={handlePageSizeChange}
          dropdownOptions={dropdownOptions}
          currentPage={currentPage}
          selectedValue={selectedValue}
          totalCount={totalCount}
          setIsOpen={setIsopen}
          accountType="non-internal"
        />
      </div>
    </div>
  );
};

export default PrivateTxnValidate;
